export const BuildingMenuType = {
    HOME: 'HOME',
    FLOOR: 'FLOOR',
    SEARCH: 'SEARCH',
    FNB: 'FNB',
    EVENT: 'EVENT',
    PARKING: 'PARKING',
    FACILITIES: 'FACILITIES',
    FAQ: 'FAQ',
} as const;

export type BuildingMenuType = (typeof BuildingMenuType)[keyof typeof BuildingMenuType];
